import QueryString from "query-string";

export default {
    getQueryParam(url, param) {
        return QueryString.parseUrl(url).query[param];
    },

    buildQuery(url, query) {
        return `${url}?${QueryString.stringify(query)}`;
    }
}


// WEBPACK FOOTER //
// ./js/utils/Uri.js